/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'
import store from '@/store/'
import router from '@/router'
import { serialize } from '@/util/util'
import { getToken } from '@/util/auth'
import { Message } from 'element-ui'
import website from '@/config/website'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Base64 } from 'js-base64'
import Vue from 'vue';
// var test = false;
// 处理返回参数为-1的空值
const filterNull = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === -1) {
      obj[key] = ''
    } else if (typeof obj[key] === 'object') {
      filterNull(obj[key])
    }
  })
}

// 默认超时时间
axios.defaults.timeout = 60000
// 返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL, // api的base_url
  // NProgress 配置
  NProgress.configure({
    showSpinner: false
  })
// http request拦截
axios.interceptors.request.use(config => {
  // 开启 progress bar
  NProgress.start()
  const meta = (config.meta || {})
  const isToken = meta.isToken === false
  config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`
  if (getToken() && !isToken) {
    // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    config.headers['Lebo-Auth'] = 'bearer ' + getToken()
  }

  // headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize) {
    config.data = serialize(config.data)
  }
  return config
}, error => {
  return Promise.reject(error)
})
// http response 拦截
axios.interceptors.response.use(res => {
  // 关闭 progress bar
  NProgress.done()
  // 获取状态码
  const status = res.data.code || res.status
  const statusWhiteList = website.statusWhiteList || []
  const message = res.data.msg || res.data.message || res.data.error_description || '未知错误'
  // 如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res)
  // 如果是401则跳转到登录页面
  if (status === 401) {
    store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }))
    return Promise.reject(new Error(message))
  }
  // 如果请求为非200否者默认统一处理
  if (status === 404) {
    Message.error('资源不存在！')
    return Promise.reject(new Error(message))
  }
  // if (!test) {
  //   test = true;
  //   Vue.prototype.$confirm(message, '系统错误', {
  //     confirmButtonText: '确认',
  //     showClose: false,
  //     showCancelButton: false,
  //     closeOnClickModal: false,
  //     type: 'error'
  //   })
  // }
  if (status !== 200) {
    if (status === 4000) {
      Vue.prototype.$confirm(message, 'Warning', {
        confirmButtonText: '确认',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        type: 'error'
      })
    } else {
      Message({
        message: message,
        type: 'error'
      })
    }
    return Promise.reject(new Error(message))
  }
  if (res.data.data) filterNull(res.data.data)
  return res
}, error => {
  NProgress.done()
  return Promise.reject(new Error(error))
})

export default axios
